import { Card, Box, Typography, Divider, Avatar, IconButton } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';

export default function DriverInfoDisplay({ driver, displayCallButton = true }) {
    const initial = driver?.fullName ? driver.fullName.charAt(0).toUpperCase() : '?';

    if (!driver) {
        return null;
    }

    return (
        <Card
            sx={{
                width: '80%',
                maxWidth: 400,
                borderRadius: 4,
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                boxShadow: 3,
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-evenly',
                    alignItems: 'center',
                }}
            >
                <Box
                    sx={{
                        border: '2px solid #E0E0E0',
                        p: '6px 14px',
                        borderRadius: 2,
                    }}
                >
                    <Typography variant="h6" fontWeight="bold">
                        {driver?.vehicleDetails?.licensePlate}
                    </Typography>
                </Box>

                <img
                    src="/e-rickshaw-cropped-green-glow-and-stars.png"
                    style={{ width: 96, height: 80 }}
                />
            </Box>

            <Divider sx={{ width: '100%' }} />

            {/* Call Button + Driver Details */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                {displayCallButton && (
                    <a href={`tel:${driver?.phoneNumber}`} style={{ textDecoration: 'none' }}>
                        <IconButton
                            size="large"
                            sx={{
                                bgcolor: '#1b5e20',
                                width: 55,
                                height: 55,
                                color: 'white',
                                '&:hover': { bgcolor: '#174d1a' },
                            }}
                        >
                            <PhoneIcon fontSize="medium" />
                        </IconButton>
                    </a>
                )}

                <Avatar
                    sx={{
                        bgcolor: 'transparent',
                        border: '3px solid #2e7d32',
                        color: '#2e7d32',
                        width: 48,
                        height: 48,
                        fontWeight: 'bold',
                        fontSize: '20px',
                    }}
                >
                    {initial}
                </Avatar>

                <Typography variant="h6" fontWeight="700">
                    {driver?.fullName}
                </Typography>
            </Box>
        </Card>
    );
}
